import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { ModalOpenerOptions } from '../modal-opener/modal-opener.component';

@Component({
  selector: 'div[data-component-type=banner]',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerComponent implements OnInit {

  @Input() title: string = "正在申请"
  @Input() text!: string
  @Input() requirement!: string
  @Input() opener!: ModalOpenerOptions
  @Input() image: string | undefined
  offset$: Observable<number> = fromEvent(window, 'scroll').pipe(
    map(() => {
      const offset = document.documentElement.scrollTop / 2 + 1
      if (offset % 2 === 0) return offset
      return Math.floor(offset / 2) * 2
    }),
    distinctUntilChanged()
  )

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

}

export interface BannerOptions {
  id: string,
  type: 'intro-component',
  text: string,
  title: string,
  requirement?: string,
  opener?: ModalOpenerOptions,
  image?: string
}